import { buildTweetHTML } from "./tweet-builder";
import { tweetCSS } from "./tweetCSS";
export class TwitterLiteEmbed extends HTMLElement {
    constructor() {
        super();
        this.fetchingStatus = "canStart";
        this.setupDom();
    }
    static get observedAttributes() {
        return ["url"];
    }
    get url() {
        return this.getAttribute("url") || "";
    }
    attributeChangedCallback(name, oldVal, newVal) {
        switch (name) {
            case "url":
                if (newVal !== oldVal) {
                    this.hydrateTweet();
                }
                break;
            default:
                break;
        }
    }
    async hydrateTweet() {
        this.tweet = await this.fetchTweet();
        this.renderTweet();
    }
    async fetchTweet() {
        if (!this.url || this.fetchingStatus !== "canStart") {
            return;
        }
        this.fetchingStatus = "fetching";
        const res = await fetch(`/api/fetch-tweet?url=${this.url}`);
        if (res.ok) {
            const tweet = await res.json();
            this.fetchingStatus = "fetched";
            return tweet;
        }
        else {
            this.fetchingStatus = "error";
            return undefined;
        }
    }
    setupDom() {
        const prerender = this.children[0];
        const shadowDom = this.attachShadow({ mode: "open" });
        shadowDom.innerHTML = `<style>${tweetCSS}</style>`;
        this.contentRef = document.createElement("div");
        if (prerender) {
            if (!prerender.className.includes("static-tweet-embed")) {
                this.contentRef.className = "static-tweet-embed";
            }
            this.contentRef.append(prerender);
        }
        shadowDom.append(this.contentRef);
    }
    renderTweet() {
        if (this.tweet) {
            this.contentRef.innerHTML = buildTweetHTML(this.tweet);
        }
    }
}
customElements.define("twitter-lite", TwitterLiteEmbed);
//# sourceMappingURL=twitter-lite-embed.js.map